import React from 'react';
import Banner from "../../../../../assets/images/BreachRisk_Verification.svg";
import BRSubdomainsProvidingTable
    from "../../../../../components/customBreachBits/BreachRiskValidationProviding/BRSubdomainsProvidingTable";
import BRDomainsProvidingTable
    from "../../../../../components/customBreachBits/BreachRiskValidationProviding/BRDomainsProvidingTable";
import BRTargetsProvidingTable
    from "../../../../../components/customBreachBits/BreachRiskValidationProviding/BRTargetsProvidingTable";
import BRIdentitiesProvidingTable
    from "../../../../../components/customBreachBits/BreachRiskValidationProviding/BRIdentitiesProvidingTable";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import {Col, Row} from "reactstrap";
import PremiumCustomersOnlyWrapper
    from "../../../../../components/customBreachBits/BRSocialReports/PremiumCustomersOnlyWrapper";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity, bbFindEntityWithinPortfolioOrSelf, bbFindUsersOnboardingProgress,
    isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import {useSelector} from "react-redux";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";
import OnboardingItemNotApplicableButton
    from "../../../../../components/customBreachBits/OnboardingProgress/OnboardingItemNotApplicable";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";


const Dashboard= ({
                      portfolioView = false
                  }) => {
    const hasEarlyAccess = EarlyAccessWrapper();
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);
    const {customers, customerInView,} = useSelector(({customer}) => customer);

    const customer = customers ? customerInView ? customers[customerInView] : null : null;

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");
    // const isTrustedAgent = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    const userOnboardingProgress = myEntity && bbFindUsersOnboardingProgress(myEntity, authUser);

    const completedOnboardingItems = userOnboardingProgress && userOnboardingProgress.filter(item => item.value === true).length;
    const totalOnboardingItems = userOnboardingProgress && userOnboardingProgress.length;
    const percentOnboardingComplete = userOnboardingProgress ? (completedOnboardingItems/totalOnboardingItems) * 100 : 0;

    console.log("Verifications page portfolioView", portfolioView);

    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                  </div>
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>The fast track to high fidelity.</h3>
                  <p>The higher your fidelity, the more reliable your BreachRisk™ Score and BreachRisk™ Report. While fidelity can naturally increase over time, your indications where your IT infrastructure exists is a critical piece. Let others know your score covers everything by increasing your fidelity.</p>

              </div>
          </div>

          <br/>
          {(portfolioView && (isAdmin || isTrustedAgentForThisEntity)) || !portfolioView
              ? <>
                  <hr/>
                  <VerifiedOwnershipRequiredDialog>

                      <h1>Verifications</h1>
                      <p>Verify the IP Addresses, Domains, and Subdomains of your infrastructure. Ensure these lists
                          accurately reflect your understanding of your cyberspace.</p>
                      <p><em>
                          Elements added to Verifications will appear in technical details and reports at the conclusion of the next scoring cycle.
                      </em></p>

                      {percentOnboardingComplete && percentOnboardingComplete !== 100 && isAdministratorForThisEntity
                          ? <Row className={"row"} style={{marginBottom: "-12px", textDecoration: "underline"}}>
                              <Col className={"col-12"}>
                                  <small className={"float-right align-bottom "}><OnboardingItemNotApplicableButton text={"No IP Addresses To Add?"} progressItem={"ipsNA"}/></small>
                              </Col>
                          </Row>
                          : null}
                      <div className="row mt-0 pt-0">
                          <div className="col-12 mt-0 pt-0">
                              <BRTargetsProvidingTable portfolioView={portfolioView}/>
                          </div>
                      </div>


                      {percentOnboardingComplete && percentOnboardingComplete !== 100 && isAdministratorForThisEntity
                          ? <Row className={"row"} style={{marginBottom: "-12px", textDecoration: "underline"}}>
                              <Col className={"col-12"}>
                                  <small className={"float-right align-bottom "}><OnboardingItemNotApplicableButton text={"No Domains To Add?"} progressItem={"domainsNA"}/></small>
                              </Col>
                          </Row>
                          : null}
                      <div className="row">
                          <div className="col-12">
                              <BRDomainsProvidingTable portfolioView={portfolioView}/>
                          </div>
                      </div>

                      <div className="row">

                          <div className="col-12">
                              <BRSubdomainsProvidingTable portfolioView={portfolioView}/>
                          </div>
                      </div>

                      {/*{hasEarlyAccess ?*/}
                          <>
                              {percentOnboardingComplete && percentOnboardingComplete !== 100 && isAdministratorForThisEntity
                                  ? <Row className={"row"} style={{marginBottom: "-12px", textDecoration: "underline"}}>
                                      <Col className={"col-12"}>
                                          <small className={"float-right align-bottom "}><OnboardingItemNotApplicableButton text={"No Identities To Add?"} progressItem={"identitiesNA"}/></small>
                                      </Col>
                                  </Row>
                                  : null}
                              <div className="row">
                                  <div className="col-12">
                                      <PremiumCustomersOnlyWrapper>
                                          <BRIdentitiesProvidingTable portfolioView={portfolioView}/>
                                      </PremiumCustomersOnlyWrapper>
                                  </div>
                              </div>
                          </>
                          {/*:*/}

                          {/*<Row>*/}
                          {/*    <Col>*/}
                          {/*        <></>*/}
                          {/*    </Col>*/}
                          {/*</Row>*/}


                      {/*}*/}
                  </VerifiedOwnershipRequiredDialog>

                  <br/>
                  <hr/>
              </>
              : <>
                  <br/>
                  <br/>
                  <br/>
                  <Tooltip title={"If you need these details, this company will need to approve a request."} link={`https://support.breachbits.com/knowledge/requesting-access`}>
                      <h2 className={"text-center"}>You don't have Trusted Agent privileges for this Entity <InfoSharpIcon/></h2>
                  </Tooltip>

                  <br/>
                  <br/>

                </>
          }
      </div>
        </div>
        // </MultiBoardWrapper>
    )
}
export default Dashboard;